<template>
  <div class="content">
    <el-form
      class="form"
      :model="ruleForm"
      ref="form"
      label-width="110px"
      label-position="right"
      :rules="rules"
      :disabled="formDisabled"
    >
      <el-row>
        <el-col :span="12">
          <el-form-item label="专家姓名" prop="expertName">
            <el-input placeholder="请填写专家姓名" v-model="ruleForm.expertName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属地区" prop="region">
            <el-select v-model="ruleForm.region" clearable placeholder="请选择所属地区">
              <el-option
                v-for="item in areaOptions"
                :key="item.value"
                :label="item.label"
                :value="item.label"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别" prop="sex">
            <el-select v-model="ruleForm.sex" clearable placeholder="请选择性别">
              <el-option key="0" label="男" :value="1"></el-option>
              <el-option key="1" label="女" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="学历" prop="education">
            <el-input placeholder="请填写学历" v-model="ruleForm.education"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="所属行业" prop="industry">
            <el-select v-model="ruleForm.industry" clearable placeholder="请选择所属行业">
              <el-option
                v-for="item in industryOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="职称" prop="technicalTitle">
            <el-input placeholder="请输入职称" v-model="ruleForm.technicalTitle"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="研究领域" prop="researchField">
        <el-select v-model="ruleForm.researchField" clearable placeholder="请选择研究领域" multiple>
          <el-option
            v-for="item in domainOptions"
            :key="item.id"
            :label="item.label"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="工作单位" prop="workUnit">
        <el-input placeholder="请输入工作单位" v-model="ruleForm.workUnit"></el-input>
      </el-form-item>
      <el-form-item label="发布时间" prop="publishedTime">
        <el-date-picker
          v-model="ruleForm.publishedTime"
          type="date"
          placeholder="选择发布时间"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="科研工作简介" prop="researchWork">
        <editor
          refName="researchWork"
          :placeholderText="'请填写科研工作简介'"
          v-model="ruleForm.researchWork"
          :upload-url="uploadURL"
          :img-show-url="imgUrl"
          :disabled="formDisabled"
        ></editor>
      </el-form-item>
      <el-form-item label="形象照" prop="logo">
        <el-upload
          class="avatar-uploader"
          :action="this.uploadURL"
          name="file"
          :show-file-list="false"
          :on-success="
            (response, file, fileList) => handlePictureCardPreview(response, file, fileList, 'logo')
          "
          :before-upload="beforeAvatarUpload"
          :disabled="formDisabled"
        >
          <img v-if="ruleForm.logo" :src="logo[0].url" class="img_border" />
          <i
            v-else
            class="el-icon-plus avatar-uploader-icon"
            :class="{ is_border: !ruleForm.logo }"
          ></i>
          <span class="upload_btn" v-if="!ruleForm.logo">上传图片</span>
          <span v-else class="upload_btn">更换图片</span>
        </el-upload>
        <span class="del_img" v-show="ruleForm.logo && !formDisabled">
          <i class="el-icon-error" @click="deleteImg('logo')"></i>
        </span>
      </el-form-item>
      <el-row>
        <el-form-item label="获得荣誉">
          <el-button type="text" @click="addHonour()">+添加荣誉</el-button>
        </el-form-item>
        <el-form-item label="在线状态">
          <el-switch
            v-model="ruleForm.onlineFlag"
            :active-value="1"
            active-text="在线"
            inactive-text="离线"
            :inactive-value="0"
          ></el-switch>
        </el-form-item>
        <el-col v-for="(item, index) in ruleForm.dtl" :key="index" :span="24">
          <p style="width: 130px; text-align: right;margin-top: 0;">
            荣誉({{ index + 1 }})
            <i class="el-icon-delete" style="margin-left: 5px;" @click="deleteHonour(index)"></i>
          </p>
          <el-form-item label="荣誉名称" prop="`dtl.${index}.honourName`">
            <el-input placeholder="请输入荣誉名称" v-model="item.honourName"></el-input>
          </el-form-item>
          <el-form-item label="附件">
            <up-load
              :fileList="item.fileList"
              :limit="1"
              :index="index"
              @change="uploadChange"
            ></up-load>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="发布" prop="publishedFlag">
        <el-switch v-model="ruleForm.publishedFlag" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import editor from "@/components/tinymce-editor/tinymce-editor";
import upLoad from './upLoad.vue';

export default {
  props: ['formDisabled', 'messageId'],
  components: {
		editor,
    upLoad
	},
  data() {
    return{
      areaOptions: [{
					value: "1",
					label: "兰州市",
				},{
					value: "2",
					label: "嘉峪关市",
				},{
					value: "3",
					label: "金昌市",
				},{
					value: "4",
					label: "白银市",
				},{
					value: "5",
					label: "天水市",
				},{
					value: "6",
					label: "武威市",
				},{
					value: "7",
					label: "张掖市",
				},{
					value: "8",
					label: "酒泉市",
				},{
					value: "9",
					label: "平凉市",
				},{
					value: "10",
					label: "庆阳市",
				},{
					value: "11",
					label: "定西市",
				},{
					value: "12",
					label: "陇南市",
				},{
					value: "13",
					label: "临夏回族自治州",
				},{
					value: "14",
					label: "甘南藏族自治州",
				},
      ],
      industryOptions: [{
					value: 4,
					label: "金融专家",
				},{
					value: 1,
					label: "技术专家",
				},
				{
					value: 2,
					label: "财会专家",
				},
				{
					value: 3,
					label: "管理专家",
				}
      ],
      domainOptions: [],
      ruleForm: {
        expertName: null, // 专家姓名
        region: null, // 所属地区
        sex: null, // 性别：1男, 2女
        education: null, // 学历
        industry: null, // 所属行业：1技术专家 2财会专家 3管理专家
        technicalTitle: null, // 职称
        researchField: [], // 研究领域json串
        workUnit: null, // 工作单位
        researchWork: null, // 科研工作简介
        publishedTime: null,
        publishedFlag: false,
        dtl: [
          {
            financeExpertTalentId: null,
            honourName: null,
            appendixSrc: null,
            fileList: []
          }
        ], //荣誉列表
        logo: null
      },
      rules: {
        expertName: [{
					required: true,
					message: "请填写标题",
					trigger: "blur"
				}],
        region: [{
					required: true,
					message: "请选择所属地区",
					trigger: "change"
				}],
        sex: [{
					required: true,
					message: "请选择性别",
					trigger: "change"
				}],
        // education: [{
				// 	required: true,
				// 	message: "请填写学历",
				// 	trigger: "blur"
				// }],
        industry: [{
					required: true,
					message: "请选择所属行业",
					trigger: "change"
				}],
        // technicalTitle: [{
				// 	required: true,
				// 	message: "请填写职称",
				// 	trigger: "blur"
				// }],
        // researchField: [{
				// 	required: true,
				// 	message: "请选择研究领域",
				// 	trigger: "change"
				// }],
        workUnit: [{
					required: true,
					message: "请填写工作单位",
					trigger: "blur"
				}],
        researchWork: [{
          required: true,
					message: "请填写科研工作简介",
					trigger: "blur"
        }],
				publishedTime: [{
					required: true,
					message: "请选择日期",
					trigger: "change"
				}],
        logo: [{
					required: true,
					message: "请选择logo",
					trigger: "change"
				}],
      },
      uploadIndex: 0,
      logo: []
    }
  },
  methods: {
    parentHandleclick(e) {
      this.$refs.form.validate((val) => {
        if (val) {
          const params = {
            ...this.ruleForm,
            publishedFlag: this.ruleForm.publishedFlag ? 1 : 0
          }
          params.researchField = JSON.stringify(this.ruleForm.researchField);
          const dtl = params.dtl.map((item) => {
            return {
              id: item.id ? item.id : null,
              financeExpertTalentId: this.messageId ? this.messageId : null,
              honourName: item.honourName,
              appendixSrc: JSON.stringify(item.fileList)
            }
          })
          if(this.messageId) {
            params.honourUpdateReqVOS = dtl
          } else if(dtl.length>0&&dtl[0].honourName){
            params.honourCreateReqVOS = dtl
          } else {
            params.honourCreateReqVOS = null
          }
          e && e(params)
        }
      });
    },
    addHonour() {
      this.ruleForm.dtl.push({
        financeExpertTalentId: this.messageId ? this.messageId : null,
        honourName: null,
        appendixSrc: null,
        fileList: []
      })
    },
    deleteHonour(index){
      if (this.ruleForm.dtl.length<=1) return
      this.ruleForm.dtl.splice(index, 1);
    },
    uploadChange(list, index) {
      this.ruleForm.dtl[index].fileList = list;
    },
    getGroup() {
      this.http
        .post(`${this.urlConfig.devUrl}apij2/admin-api/system/dict-data/getGroup`, {
          dictTypes: ['resource_engaged_field']
        })
        .then(res => {
          if (res.code === 0) {
            const { resource_engaged_field } = res.data;
            this.domainOptions = [...resource_engaged_field];
          }
        });
    },
    initDate(id) {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/expert-talent/get?id=${id}`)
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              ...res.data
            }
            this.logo = res.data.logo ? JSON.parse(res.data.logo) : [];
            this.ruleForm.publishedFlag = Boolean(res.data.publishedFlag);
            if (res.data.researchField) {
              this.ruleForm.researchField = JSON.parse(res.data.researchField).map(Number)
            }
            if(res.data.dtl && res.data.dtl.length > 0) {
              this.ruleForm.dtl = res.data.dtl.map((item) => {
                return {
                  id: item.id,
                  honourName: item.honourName,
                  financeExpertTalentId: id,
                  fileList: JSON.parse(item.appendixSrc)
                }
              })
            }
            console.log(this.ruleForm.dtl)
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
    },
    deleteImg() {
      this.logo = []
      this.ruleForm.logo = null
    },
    beforeAvatarUpload(file) {
			let type = false;
			if (
				file.type === "image/jpeg" ||
				file.type === "image/png" ||
				file.type === "image/jpg" ||
				file.type === "image/gif" ||
				file.type === "image/bmp"
			) {
				type = true;
			}

			const isLt2M = file.size / 1024 / 1024 < 30;
			if (!type) {
				this.$message.error("上传图片只能是 JPEG/jpg/png/gif/bmp 格式!");
			}
			if (!isLt2M) {
				this.$message.error("上传图片大小不能超过 30MB!");
			}
			return type && isLt2M;
		},
    handlePictureCardPreview(response, file, fileList, type) {
      console.log(fileList)
			// this.ruleForm.logo = file.data.store_result;
      if (response.code == 0) {
        let arr = []
        if(fileList.length > 0) {
          // fileList.map(item => {
            arr.push({
              url: file.size ? this.imgUrl + file.response.data.store_result : file.url,
              name: file.name
            });
          // });
        }
        if(arr.length > 0) {
          this[type] = arr;
          this.ruleForm[type] = JSON.stringify(arr);
        }else{
          this.ruleForm[type] = '';
          this[type] = [];
        }
      }
		},
  },
  created() {
    this.getGroup()
    if(this.messageId) {
      this.initDate(this.messageId)
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  .del_img {
    position: absolute;
    top: -7px;
    left: 220px;
    color: #00a1ff;
  }

  .del_img:hover {
    cursor: pointer;
    color: #f00;
  }

  .del_img i:before {
    font-size: 20px;
  }
  .img_border {
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
    width: 243px;
    height: 154px;
    display: block;
  }
  /deep/ {
    .el-input,
    .el-select {
      width: 100%;
    }
  }

  /deep/ .avatar-uploader {
    width: 243px;
    height: 198px;
    border: 1px dashed #d9d9d9 !important;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  /deep/ .upload-demo {
    border: none;
  }

  /deep/ .el-upload:hover {
    border-color: #409eff !important;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 243px;
    height: 154px;
    line-height: 154px;
    text-align: center;
  }

  /deep/ .upload-demo {
    margin-top: 10px;
    /deep/.el-upload {
      /deep/.el-button {
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        background: rgba(66, 141, 255, 1);
        border-radius: 18px;
        padding: 10px 25px;
      }
    }
  }
}
</style>
